// Hilfsfunktionen fuer Web Push (Service-Worker-Registrierung + Abo-Verwaltung).

export function registriereServiceWorker() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function pushWirdUnterstuetzt() {
  return "serviceWorker" in navigator && "PushManager" in window;
}

export async function holeAktivesAbo() {
  if (!(await pushWirdUnterstuetzt())) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

export async function pushAktivieren(API, praeferenzen = { feedback: true, kuendigung: true, vertrag: true }) {
  const reg = await navigator.serviceWorker.ready;
  const berechtigung = await Notification.requestPermission();
  if (berechtigung !== "granted") throw new Error("Berechtigung verweigert");

  const res = await fetch(`${API}/push/vapid-public-key`);
  const { public_key } = await res.json();
  if (!public_key) throw new Error("Push ist serverseitig nicht eingerichtet");

  const subscription = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(public_key),
  });

  await fetch(`${API}/push/abonnieren`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...subscription.toJSON(), ...praeferenzen }),
  });
  return subscription;
}

export async function pushDeaktivieren(API) {
  const abo = await holeAktivesAbo();
  if (!abo) return;
  const endpoint = abo.endpoint;
  await abo.unsubscribe();
  await fetch(`${API}/push/abmelden`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ endpoint }),
  });
}

export async function pushEinstellungenLaden(API) {
  const abo = await holeAktivesAbo();
  if (!abo) return null;
  const res = await fetch(`${API}/push/einstellungen?endpoint=${encodeURIComponent(abo.endpoint)}`);
  if (!res.ok) return null;
  return res.json();
}

export async function pushEinstellungenSpeichern(API, praeferenzen) {
  const abo = await holeAktivesAbo();
  if (!abo) return;
  await fetch(`${API}/push/einstellungen`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ endpoint: abo.endpoint, ...praeferenzen }),
  });
}
